import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    country: "",
    currentView: "",
    userData: [],
    user: [],
  },
  mutations: {
    changeView(state, view)
    {
      state.currentView = view;
    },
    changeCountry(state, view)
    {
      state.country = view;
    },
    setUserData(state, payload)
    {
      state.userData = payload
    },
    setUser(state, payload)
    {
      state.user = payload
    }
  },
  //dispatch this action in any component to change view
  actions: {
    loadView({ commit }, view)
    {
      commit('changeView', view)
    },
    loadCountry({ commit }, view)
    {
      commit('changeCountry', view)
    },
  }
})

export default store;
